<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div style="height:50px; margin:5px 16px 0 16px;">
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd(0)">新增</el-button>
                </div>
            </div>
            <el-table
                :data="menus"
                style="width: 100%;margin-bottom: 20px"
                row-key="id"
                border
                :tree-props="{children: 'children'}">
                <el-table-column type="index" :index="indexMethod" label="序号" width="50">
                </el-table-column>
                <!-- <el-table-column prop="id" label="唯一标识" :show-overflow-tooltip="true" width="150">
                </el-table-column> -->
                <el-table-column prop="text" label="名称" :show-overflow-tooltip="true" width="200">
                </el-table-column>
                <el-table-column prop="attributes.icon" label="图标">
                    <template slot-scope="scope">
                        <i :class="scope.row.attributes.icon"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.type" label="类型">
                     <template slot-scope="scope">
                        <div v-if="scope.row.attributes.type == 0">
                            目录
                        </div>
                        <div v-else-if="scope.row.attributes.type == 1">
                            菜单
                        </div>
                        <div v-else-if="scope.row.attributes.type == 2">
                            按钮
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.url" label="地址">
                </el-table-column>
                <!-- <el-table-column prop="attributes.perms" label="权限标识">
                </el-table-column> -->
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                         <el-button v-if="scope.row.parentId == 0"
                            @click.native.prevent="setAdd(scope.row.id)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button :disabled="scope.row.id == 1"
                            @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" :disabled="scope.row.id == 1"
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 新增/修改弹出框 -->
        <el-dialog :title="tval==1?'新增':'修改'"  :close-on-click-modal="false" :visible.sync="editVisible" :before-close="dialogClose" width="30%">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                 <!--<el-form-item prop="id" label="唯一标识"  v-if="tval == 1">
                    <el-input v-model="form.id" maxlength="32" placeholder="不填写,默认会自动生成(推荐不填写)"></el-input>
                </el-form-item>  -->
                
                <el-form-item prop="name" label="名称">
                    <el-input v-model="form.name" maxlength="50"></el-input>
                </el-form-item> 

                <el-form-item prop="icon" label="图标">
                    <el-input v-model="form.icon" maxlength="50"></el-input>
                </el-form-item>

                <el-form-item label="类型">
                    <el-radio-group v-model="form.type">
                        <el-radio :label='0' >目录</el-radio>
                        <el-radio :label='1' >菜单</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item prop="url" label="地址">
                    <el-input v-model="form.url" maxlength="50"></el-input>
                </el-form-item>

                <el-form-item prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" type="number"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import http from '../../../../common/http';
    export default {
        name:"Menu",
        data(){
            return{
                menus:[],
                editVisible: false,
                delVisible: false,
                tval:1,
                form: {
                    id:'',
                    parentId:0,
                    name: '',
                    url: '',
                    perms: '',
                    type:'',
                    icon:'',
                    orderNum:1
                },
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    icon: [
                        { required: true, message: '请输入图标', trigger: 'blur' }
                    ],
                    url: [
                        { required: true, message: '请输入地址', trigger: 'blur' }
                    ]
                },
                menuName:''
            }
        },
        created:function () {
            this.getData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                let url  = this.menuUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.menus=res.data.menus;    
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(parentId){
                this.tval=1;
                this.form.id="";
                this.form.parentId=parentId;
                this.form.name="";
                this.form.url="";
                this.form.perms="";
                this.form.type=0;
                this.form.icon="";
                this.form.orderNum=1;
                this.editVisible=true;
            },
            //修改界面
            setUpdate(data){
                this.tval=2;
                this.form.id=data.id;
                this.form.parentId=data.parentId;
                this.form.name=data.text;
                this.form.url=data.attributes.url;
                this.form.perms=data.attributes.perms;
                this.form.type=data.attributes.type;
                this.form.icon=data.attributes.icon;
                this.form.orderNum=data.attributes.orderNum;
                this.editVisible=true;
                this.$refs['form'].validate((valid) => {});
            },
            //保存
            save(){
               this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url="";
                        if(this.tval==1){
                            url = this.menuAddUrl;
                        }else if(this.tval==2){
                            url = this.menuUpdateUrl;
                        }
                        let data = {
                            id:this.form.id,
                            parentId:this.form.parentId,
                            name:this.form.name,
                            url:this.form.url,
                            perms:this.form.perms,
                            type:this.form.type,
                            icon:this.form.icon,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.editVisible=false;
                                this.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            //删除
            del(data){
                 this.form.id=data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.menuDelUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.delVisible=false;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }
    /* el-table {
        height: 100%;
    } */
    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/sys/menu/Menu.vue